import { merge } from '../../helper';

import type { IToastConfig } from './types';
import { create, type TypeBuildReturn } from './create';
import { show } from './utils';

// ----------------------------------------------------------------------------

export interface IStartConfig extends IToastConfig {
    placement?: string;
    show?: boolean;
}

// ----------------------------------------------------------------------------

function start(config: IStartConfig = {}): TypeBuildReturn {
    // Default Config
    const defConfig: IStartConfig = {
        toastContainer: {
            placement: config.placement ?? 'bottomright',
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (toast)
    const toast = create({
        merge: defConfig,
        toastContainer: {
            class: {
                add: 'position-fixed',
            },
            style: {
                padding: '14px',
            },
        },
        container: {
            parent: document.body,
        },
    });

    // If using show
    if (defConfig.show !== false) {
        show(toast.element);
    }

    // ------------------------------------------------------------------------

    // Return
    return toast;
}

// ----------------------------------------------------------------------------

export { start };
